import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/producer-revenue-calculator/page.tsx")